<div *ngIf="!similarDocuments" class="d-flex flex-column {{iframeClass}}" [ngStyle]="{height: height}">
    <sq-preview-document-iframe  [sandbox]="sandbox" [downloadUrl]="downloadUrl" (onPreviewReady)="document = $event">
        <sq-preview-tooltip #tooltip [previewDocument]="document" [previewData]="data"></sq-preview-tooltip>
    </sq-preview-document-iframe>
</div>
<ul class="list-group" *ngIf="!!similarDocuments">
    <li *ngFor="let doc of similarDocuments" class="list-group-item d-flex justify-content-between align-items-center" style="background-color: transparent;">
        <sq-result-title [record]="doc" [titleLinkBehavior]="'open'"></sq-result-title>
        <div class="d-flex">
            <span class="badge rounded-pill bg-secondary pt-1">{{100*doc.globalrelevance | number:'1.0-0'}}</span>
            <a href="#" (click)="openSimilarDoc(doc)" class="open-record ms-2" title="Open document in workspace">
                <i class="fas fa-arrow-circle-right"></i>
            </a>
        </div>
    </li>
</ul>